import React, { Suspense, useEffect, useState } from 'react';
import { Panel } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { navigate } from 'raviger';

import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';
import Permission from '../../components/Permission/Permission';

import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';

import Spinner from '../../components/Spinner/Spinner';
import * as constants from '../../constants';

const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));
const ReportList = React.lazy(() => import('../../components/Lists/ReportList/ReportList'));

function FranchiseReports() {
    const dispatch = useDispatch();

    const [isMounted, setIsMounted] = useState(false);
    const pagePermission = constants.PERMISSION_REPORTS_VIEWREPORTS;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    useEffect(() => {
        if (!hasPermission) { return; }
        if (isMounted) { return; }

        dispatch(breadcrumbAddRoute({ key: 'reports', parent: 'Reports', text: 'View Reports', path: window.location.pathname }));
        setIsMounted(true);
    }, [hasPermission, isMounted, dispatch]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);


    const selectedHandler = (report) => {
        navigate(`/reports/report/${report.id}`);
    };


    return (
        <>
            <SideMenu activeKey="reports" />
            <div className="content-body">
                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />
                {hasPermission && isMounted &&
                    <Suspense fallback={<Spinner text="Loading..." />}>

                        <div style={{ paddingRight: '15px' }}>
                            <PageHeader title="View Reports" />
                            <Panel>
                                <Panel.Body>
                                    <ReportList
                                        canEdit={canEdit}
                                        selected={(report) => selectedHandler(report)} />
                                </Panel.Body>
                            </Panel>
                        </div>
                    </Suspense>
                }
            </div>
        </>
    );

};
export default withAuthentication(withLayout(FranchiseReports));